import Fuse, { FuseOptionKey, IFuseOptions } from "fuse.js";

export function createFuseSearch<T>(elementsToSearch: T[], keysArray: FuseOptionKey<T>[], options: IFuseOptions<T> = {}): Fuse<T> {
    return new Fuse(elementsToSearch, {
        keys: keysArray,
        minMatchCharLength: 2,
        threshold: 0.45,
        ignoreLocation: false,
        ...options,
    });
}
